import {
  ChartPieSlice, Users, Buildings, UserCircle, FileText, Money, Percent, Bank, Vault, Scales, UsersThree, Car, CalendarBlank,
} from "@phosphor-icons/react";

// Módulos del sistema sujetos a permisos por empresa (incluye Dashboard).
export const MODULES = [
  { id: "dashboard", label: "Dashboard", to: "/dashboard", icon: ChartPieSlice, viewOnly: true },
  { id: "propietarios", label: "Propietarios", to: "/propietarios", icon: Users },
  { id: "inmuebles", label: "Inmuebles", to: "/inmuebles", icon: Buildings },
  { id: "arrendatarios", label: "Arrendatarios", to: "/arrendatarios", icon: UserCircle },
  { id: "contratos", label: "Contratos", to: "/contratos", icon: FileText },
  { id: "cobranza", label: "Cobranza", to: "/cobranza", icon: Money },
  { id: "comisiones", label: "Comisiones", to: "/comisiones", icon: Percent },
  { id: "bancos", label: "Bancos", to: "/bancos", icon: Bank },
  { id: "depositos", label: "Depósitos", to: "/depositos", icon: Vault },
  { id: "juridico", label: "Jurídico", to: "/juridico", icon: Scales },
  { id: "rrhh", label: "Nómina / RH", to: "/rrhh", icon: UsersThree },
  { id: "vehiculos", label: "Vehículos", to: "/vehiculos", icon: Car },
  { id: "agenda", label: "Agenda", to: "/agenda", icon: CalendarBlank },
];

export const ACTIONS = [
  { id: "view", label: "Ver" },
  { id: "edit", label: "Editar" },
  { id: "delete", label: "Eliminar" },
];

export function can(user, moduleId, action = "view") {
  if (!user) return false;
  if (user.role === "admin") return false; // el Superadmin no usa los módulos
  if (user.role === "empresa_admin") return true;
  return !!user.permissions?.[moduleId]?.[action];
}

export function visibleModules(user) {
  if (!user) return [];
  return MODULES.filter((m) => can(user, m.id, "view"));
}

// Ruta de aterrizaje según rol/permisos.
export function landingPath(user) {
  if (!user) return "/login";
  if (user.role === "admin") return "/licencias";
  const vis = visibleModules(user);
  return vis[0]?.to || "/dashboard";
}
